// v3.9.28 — Philippine Standard Industrial Classification (PSIC 2019, ISIC Rev.4
// aligned): 21 sections + 88 divisions. Source: PSA (psa.gov.ph/classification/psic)
// + classification.codes. Division titles follow the ISIC Rev.4 structure PSIC is
// patterned after. Groups/classes/sub-classes can be layered later from the PSA
// Excel. The company-profile picker suggests these but still allows free text.
export interface PsicSection { code: string; name: string }
export interface PsicDivision { code: string; name: string; section: string }

export const PSIC_SECTIONS: PsicSection[] = [
  { code: "A", name: "Agriculture, forestry and fishing" },
  { code: "B", name: "Mining and quarrying" },
  { code: "C", name: "Manufacturing" },
  { code: "D", name: "Electricity, gas, steam and air-conditioning supply" },
  { code: "E", name: "Water supply; sewerage, waste management and remediation" },
  { code: "F", name: "Construction" },
  { code: "G", name: "Wholesale and retail trade; repair of motor vehicles and motorcycles" },
  { code: "H", name: "Transportation and storage" },
  { code: "I", name: "Accommodation and food service activities" },
  { code: "J", name: "Information and communication" },
  { code: "K", name: "Financial and insurance activities" },
  { code: "L", name: "Real estate activities" },
  { code: "M", name: "Professional, scientific and technical activities" },
  { code: "N", name: "Administrative and support service activities" },
  { code: "O", name: "Public administration and defense; compulsory social security" },
  { code: "P", name: "Education" },
  { code: "Q", name: "Human health and social work activities" },
  { code: "R", name: "Arts, entertainment and recreation" },
  { code: "S", name: "Other service activities" },
  { code: "T", name: "Activities of households as employers" },
  { code: "U", name: "Activities of extraterritorial organizations and bodies" },
];

export const PSIC_DIVISIONS: PsicDivision[] = [
  { code: "01", section: "A", name: "Crop and animal production, hunting and related service activities" },
  { code: "02", section: "A", name: "Forestry and logging" },
  { code: "03", section: "A", name: "Fishing and aquaculture" },
  { code: "05", section: "B", name: "Mining of coal and lignite" },
  { code: "06", section: "B", name: "Extraction of crude petroleum and natural gas" },
  { code: "07", section: "B", name: "Mining of metal ores" },
  { code: "08", section: "B", name: "Other mining and quarrying" },
  { code: "09", section: "B", name: "Mining support service activities" },
  { code: "10", section: "C", name: "Manufacture of food products" },
  { code: "11", section: "C", name: "Manufacture of beverages" },
  { code: "12", section: "C", name: "Manufacture of tobacco products" },
  { code: "13", section: "C", name: "Manufacture of textiles" },
  { code: "14", section: "C", name: "Manufacture of wearing apparel" },
  { code: "15", section: "C", name: "Manufacture of leather and related products" },
  { code: "16", section: "C", name: "Manufacture of wood and wood/cork products (except furniture)" },
  { code: "17", section: "C", name: "Manufacture of paper and paper products" },
  { code: "18", section: "C", name: "Printing and reproduction of recorded media" },
  { code: "19", section: "C", name: "Manufacture of coke and refined petroleum products" },
  { code: "20", section: "C", name: "Manufacture of chemicals and chemical products" },
  { code: "21", section: "C", name: "Manufacture of pharmaceuticals and medicinal/botanical products" },
  { code: "22", section: "C", name: "Manufacture of rubber and plastics products" },
  { code: "23", section: "C", name: "Manufacture of other non-metallic mineral products" },
  { code: "24", section: "C", name: "Manufacture of basic metals" },
  { code: "25", section: "C", name: "Manufacture of fabricated metal products (except machinery)" },
  { code: "26", section: "C", name: "Manufacture of computer, electronic and optical products" },
  { code: "27", section: "C", name: "Manufacture of electrical equipment" },
  { code: "28", section: "C", name: "Manufacture of machinery and equipment n.e.c." },
  { code: "29", section: "C", name: "Manufacture of motor vehicles, trailers and semi-trailers" },
  { code: "30", section: "C", name: "Manufacture of other transport equipment" },
  { code: "31", section: "C", name: "Manufacture of furniture" },
  { code: "32", section: "C", name: "Other manufacturing" },
  { code: "33", section: "C", name: "Repair and installation of machinery and equipment" },
  { code: "35", section: "D", name: "Electricity, gas, steam and air-conditioning supply" },
  { code: "36", section: "E", name: "Water collection, treatment and supply" },
  { code: "37", section: "E", name: "Sewerage" },
  { code: "38", section: "E", name: "Waste collection, treatment and disposal; materials recovery" },
  { code: "39", section: "E", name: "Remediation and other waste management services" },
  { code: "41", section: "F", name: "Construction of buildings" },
  { code: "42", section: "F", name: "Civil engineering" },
  { code: "43", section: "F", name: "Specialized construction activities" },
  { code: "45", section: "G", name: "Wholesale/retail trade and repair of motor vehicles and motorcycles" },
  { code: "46", section: "G", name: "Wholesale trade, except of motor vehicles and motorcycles" },
  { code: "47", section: "G", name: "Retail trade, except of motor vehicles and motorcycles" },
  { code: "49", section: "H", name: "Land transport and transport via pipelines" },
  { code: "50", section: "H", name: "Water transport" },
  { code: "51", section: "H", name: "Air transport" },
  { code: "52", section: "H", name: "Warehousing and support activities for transportation" },
  { code: "53", section: "H", name: "Postal and courier activities" },
  { code: "55", section: "I", name: "Accommodation" },
  { code: "56", section: "I", name: "Food and beverage service activities" },
  { code: "58", section: "J", name: "Publishing activities" },
  { code: "59", section: "J", name: "Motion picture, video, TV production; sound recording & music publishing" },
  { code: "60", section: "J", name: "Programming and broadcasting activities" },
  { code: "61", section: "J", name: "Telecommunications" },
  { code: "62", section: "J", name: "Computer programming, consultancy and related activities" },
  { code: "63", section: "J", name: "Information service activities" },
  { code: "64", section: "K", name: "Financial service activities, except insurance and pension funding" },
  { code: "65", section: "K", name: "Insurance, reinsurance and pension funding (except compulsory social security)" },
  { code: "66", section: "K", name: "Activities auxiliary to financial service and insurance activities" },
  { code: "68", section: "L", name: "Real estate activities" },
  { code: "69", section: "M", name: "Legal and accounting activities" },
  { code: "70", section: "M", name: "Activities of head offices; management consultancy activities" },
  { code: "71", section: "M", name: "Architectural and engineering activities; technical testing and analysis" },
  { code: "72", section: "M", name: "Scientific research and development" },
  { code: "73", section: "M", name: "Advertising and market research" },
  { code: "74", section: "M", name: "Other professional, scientific and technical activities" },
  { code: "75", section: "M", name: "Veterinary activities" },
  { code: "77", section: "N", name: "Rental and leasing activities" },
  { code: "78", section: "N", name: "Employment activities" },
  { code: "79", section: "N", name: "Travel agency, tour operator, reservation service and related activities" },
  { code: "80", section: "N", name: "Security and investigation activities" },
  { code: "81", section: "N", name: "Services to buildings and landscape activities" },
  { code: "82", section: "N", name: "Office administrative, office support and other business support activities" },
  { code: "84", section: "O", name: "Public administration and defense; compulsory social security" },
  { code: "85", section: "P", name: "Education" },
  { code: "86", section: "Q", name: "Human health activities" },
  { code: "87", section: "Q", name: "Residential care activities" },
  { code: "88", section: "Q", name: "Social work activities without accommodation" },
  { code: "90", section: "R", name: "Creative, arts and entertainment activities" },
  { code: "91", section: "R", name: "Libraries, archives, museums and other cultural activities" },
  { code: "92", section: "R", name: "Gambling and betting activities" },
  { code: "93", section: "R", name: "Sports activities and amusement and recreation activities" },
  { code: "94", section: "S", name: "Activities of membership organizations" },
  { code: "95", section: "S", name: "Repair of computers and personal and household goods" },
  { code: "96", section: "S", name: "Other personal service activities" },
  { code: "97", section: "T", name: "Activities of households as employers of domestic personnel" },
  { code: "98", section: "T", name: "Undifferentiated goods/services-producing activities of households for own use" },
  { code: "99", section: "U", name: "Activities of extraterritorial organizations and bodies" },
];

/** Match a typed industry name to its PSIC code (division 2-digit, else section letter). */
export function psicCodeForName(name: string): string | undefined {
  const n = (name || "").trim().toLowerCase();
  if (!n) return undefined;
  const div = PSIC_DIVISIONS.find((d) => d.name.toLowerCase() === n);
  if (div) return div.code;
  const sec = PSIC_SECTIONS.find((s) => s.name.toLowerCase() === n);
  return sec?.code;
}
